//const extensionId = 'mlklnelincjfdmedillihdbiohlmolmn'
const extensionId = /localhost/.test(window.location.href) ? 'mlklnelincjfdmedillihdbiohlmolmn' : 'omjhdijpgnmecceilnmnljohogjgipcf'

export default function sendRSI(request, callback) {
	chrome.runtime?.sendMessage(extensionId, request, callback)
}
